<div class="deactivate__payment">
  <div class="deactivate__payment__title vc-text-l">
    Tranfer method
  </div>
  <div class="deactivate__payment__text vc-text-m">
    By updating, your previous Paypal account details will erased and replaced with the new one.
  </div>
  <div class="deactivate__payment__button">
    <button
      class="vc-btn vc-btn--primary vc-btn--medium vc-btn--full vc-btn--notfull--md-up"
      (click)="deleteOldTransferMethod()"
    >
      Continue
    </button>
  </div>
</div>
